module.exports = __webpack_public_path__ + "static/img/015 1.73f5ee84.jpg";